import { card } from '../../cls';
import './text.less';

export var textCard = card('text');

export var content = textCard('content');
export var actions = textCard('actions');
export var paragraph = textCard('paragraph');
export var line = textCard('line');
export var action = textCard('action');